import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@air/next-icons";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixContextMenu from "@radix-ui/react-context-menu";
import classNames from "classnames";
import { contextMenuItem } from "./ContextMenuItem";
export const ContextMenuSub = (param)=>{
    let { children, className, defaultOpen, description, disabled, label, onOpenChange, open, prefix, suffix, "data-id": dataId, ...restOfProps } = param;
    const hasDescription = !!description;
    return /*#__PURE__*/ _jsxs(RadixContextMenu.Sub, {
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        open: open,
        children: [
            /*#__PURE__*/ _jsxs(RadixContextMenu.SubTrigger, {
                className: contextMenuItem({
                    description: hasDescription
                }),
                "data-testid": "CONTEXT_MENU_SUB_TRIGGER",
                "data-id": dataId,
                disabled: disabled,
                children: [
                    prefix ? /*#__PURE__*/ _jsx("div", {
                        className: classNames("mr-2 flex shrink-0 items-center gap-1", hasDescription ? "mt-0.5" : "mt-0"),
                        children: prefix
                    }) : null,
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex min-w-0 grow flex-col",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "truncate text-14",
                                children: label
                            }),
                            hasDescription ? /*#__PURE__*/ _jsx("span", {
                                className: "text-12 text-grey-10",
                                children: description
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: classNames("ml-2 flex shrink-0 items-center gap-1", hasDescription ? "mt-0.5" : "mt-0"),
                        children: [
                            suffix,
                            /*#__PURE__*/ _jsx(ChevronRight, {
                                className: "size-4"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(RadixContextMenu.Portal, {
                children: /*#__PURE__*/ _jsx(RadixContextMenu.SubContent, {
                    className: tailwindMerge("z-portal flex max-h-[var(--radix-context-menu-content-available-height)] w-[216px] min-w-[var(--radix-popper-anchor-width)] flex-col gap-2 overflow-y-auto rounded bg-surface-1 p-2 text-grey-12 shadow-popover outline-none radix-side-left:animate-slide-down radix-side-right:animate-slide-up dark:border dark:border-grey-5", className),
                    "data-testid": "CONTEXT_MENU_SUB",
                    ...restOfProps,
                    children: children
                })
            })
        ]
    });
};
